// Checks if an object is null, undefined or {}
export const isEmptyObject = (value?: { [key: string]: any } | null) => {
  return (
    value == null || // checks for both null or undefined
    (typeof value === 'object' && Object.keys(value).length === 0)
  );
};
